import axios from 'axios';

const triyoAPI = axios.create({
    baseURL: window["APP_SETTINGS"].REACT_APP_TRIYO_API_URL,
});

triyoAPI.interceptors.response.use(null, async function (response) {
    return response;
}, error => {
    console.log(error)
    return Promise.reject(error)
})

const refreshJWT = triyoAPI.interceptors.response.use(null, function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && error.config.url !== '/auth/refresh') {
        return triyoAPI.post('/auth/refresh', null, { withCredentials: true })
            .then(res => {
                if (res.status === 200) {
                    const AccessToken = res.data.AccessToken
                    triyoAPI.defaults.headers.common['Authorization'] = `Bearer ${AccessToken}`;
                    originalRequest.headers.Authorization = `Bearer ${AccessToken}`;
                    return triyoAPI(originalRequest);
                }
            })
    }
    return Promise.reject(error);
});

export default triyoAPI;